<template>
  <createTable
    :autoWidth="true"
    :tableDataItem="tableDataItem"
    :operateVisible="false"
    :tableData="historyTableData"
    :total_count="total_count"
    :current_page.sync="page"
    :papeSize.sync="per_page"
    :pageVisible="true"
    :pageData="historyPageData"
    :loading="loading"
    :scrollToTopWhenPageChange="false"
    v-bind="$attrs"
  />
</template>

<script>
import createTable from '@/components/createTable'
import { getHistoryList } from '@/services/resource'

export default {
  name: 'history-table',
  components: {
    createTable
  },
  props: {
    tableDataItem: {
      type: Array,
      required: true
    },
    itemType: {
      type: String,
      required: true
    },
    itemId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      historyTableData: [],
      page: 1,
      per_page: 50,
      total_count: 0,
      loading: false
    }
  },
  computed: {
    historyPageData () {
      return {
        page: this.page,
        per_page: this.per_page,
        total_count: this.total_count
      }
    }
  },
  watch: {
    historyPageData: {
      handler () {
        this.getHistoryList()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getHistoryList () {
      this.loading = true
      try {
        const { data } = await getHistoryList({
          item_type: this.itemType,
          item_id: this.itemId,
          page: this.page,
          per_page: this.per_page
        })
        this.loading = false
        this.historyTableData = data.versions
        this.total_count = data.pagination.total_count
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  }
}
</script>
